<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3 >
        <h4>Update Alert</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm11 md10 offset-sm3>
        <form action="" @submit.prevent="onCreateAlert">
          <v-layout row>
            <v-flex xs12 sm6>
            <v-text-field
              name="alertName"
              label="Alert Text"
              v-model="alertName"
              id="alertName"
              multi-line
            ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6>
              <v-btn 
              class="primary" 
              type="submit">
                Update Alert
              </v-btn>
              <v-btn 
              class="primary"
              @click="onDeleteAlert">
                Delete Alert
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ['notice'],
  data () {
    return {
      alertName: this.$store.getters.loadedNotice.noticeName,
      dialog: false
    }
  },
  computed: {
    formIsValid () {
      return this.alertName !== ''
    }
  },
  methods: {
    onCreateAlert () {
      if (!this.formIsValid) {
        return
      }
      if (this.alertName !== '' || this.alertName !== null) {
        this.$store.dispatch('createNotice', this.alertName)
          // this.$router.push('/alerts')
      } else {
      }
    },
    onDeleteAlert () {
      this.$store.dispatch('deleteNoticeData')
      this.$router.push('/')
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateAlert.vue?7a70d22a